import axios from "axios";

import { Listing } from "../types";

async function searchById(id: string): Promise<Listing> {
  const response = await axios
    .get<Listing>(`/nhsd/service/${id}`)
    .then((response) => {
      return response.data;
    });

  return response;
}

export default searchById;
